import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function PrivacyPolicyPage() {
  return (
    <div className="privacy-policy">
      <Container>
        <Row>
          <Col md={12} className="justify-center mt-4 mb-4">
            <h1>Privacy Policy – Amaravathi Pickles</h1>

            <p>
              <b>Effective Date:</b> [16-08-2026]
            </p>

            <p>
              At <b>Amaravathi Pickles</b>, we respect your privacy and are
              committed to protecting the personal information you provide to us.
            </p>
          </Col>
        </Row>

        <Row>
          <Col md={12} className="justify-center mt-4 mb-4">

            <h2>1. About Amaravathi Pickles</h2>
            <p>
              <b>Amaravathi Pickles</b> is a unique homemade pickle business
              based in <b>Mangalagiri, Andhra Pradesh, India</b>. We operate
              from our single shop and do not have any other branches.
            </p>

            <h2>2. Information We Collect</h2>
            <p>
              When you contact us, submit an enquiry, place an order, or request
              information through our website, Google Ads, WhatsApp, phone, or
              other communication channels, we may collect:
            </p>

            <ul>
              <li>Name</li>
              <li>Mobile or telephone number</li>
              <li>Email address</li>
              <li>Delivery address</li>
              <li>City and PIN code</li>
              <li>Product and quantity requirements</li>
              <li>Other information voluntarily provided by you</li>
            </ul>

            <h2>3. How We Use Your Information</h2>
            <p>
              We may use the information provided by you to:
            </p>

            <ul>
              <li>Respond to your enquiries</li>
              <li>Provide product information and prices</li>
              <li>Process and confirm orders</li>
              <li>Arrange delivery</li>
              <li>Provide wholesale or customised packing information</li>
              <li>Communicate regarding your order or enquiry</li>
              <li>Provide customer support</li>
              <li>Improve our products and services</li>
            </ul>

            <h2>4. Google Ads and Lead Forms</h2>
            <p>
              If you submit your information through a <b>Google Ads Lead Form</b>,
              the information you provide may be shared with Amaravathi Pickles
              so that we can respond to your enquiry.
            </p>

            <p>
              We use this information for legitimate business purposes related
              to your enquiry, products, orders, delivery, and customer
              communication.
            </p>

            <h2>5. Sharing of Information</h2>
            <p>
              We do <b>not sell or rent your personal information</b> to third
              parties.
            </p>

            <p>
              We may share necessary information with trusted service providers,
              such as delivery or logistics providers, when required to fulfil
              your order or provide the requested service.
            </p>

            <h2>6. Data Security</h2>
            <p>
              We take reasonable steps to protect the personal information
              provided by customers from unauthorized access, misuse,
              alteration, or disclosure.
            </p>

            <p>
              However, no method of electronic transmission or storage can be
              guaranteed to be completely secure.
            </p>

            <h2>7. Customer Communications</h2>
            <p>
              If you provide your mobile number or email address, we may contact
              you regarding your enquiry, order, delivery, products, or services.
            </p>

            <p>
              You may request that we stop promotional communications at any time.
            </p>

            <h2>8. Cookies and Website Information</h2>
            <p>
              Our website may use cookies or similar technologies to improve
              website functionality, understand visitor activity, and support
              advertising and analytics.
            </p>

            <p>
              You can manage cookie preferences through your browser settings.
            </p>

            <h2>9. Third-Party Services</h2>
            <p>
              Our website or advertising campaigns may use third-party services
              such as Google, WhatsApp, payment providers, or delivery services.
              These services may process information according to their own
              privacy policies.
            </p>

            <h2>10. Your Rights</h2>
            <p>
              You may contact us to:
            </p>

            <ul>
              <li>Ask what personal information we hold about you</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your information, where applicable</li>
              <li>Withdraw consent for future communications</li>
            </ul>

            <h2>11. Contact Us</h2>

            <p>
              For questions regarding this Privacy Policy or your personal
              information, please contact:
            </p>

            <p>
              <b>Amaravathi Pickles</b>
              <br />
              Mangalagiri, Andhra Pradesh, India
              <br />
              📞 <b>+919949096910</b>
              <br />
              📧 <b>[amaravathipickles@gmail.com]</b>
            </p>

            <h2>12. Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes
              will be posted on this page with the updated effective date.
            </p>

            <h2>13. Consent</h2>
            <p>
              By submitting your information through our website or Google Ads
              Lead Form, you acknowledge that you have read and understood this
              Privacy Policy.
            </p>

          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default PrivacyPolicyPage;
